import { Link, useLocation } from "react-router-dom";
import {
  IconeCalendario,
  IconeCasa,
  IconeMais,
  IconePredio,
  IconePrancheta,
} from "./Icones";
import { useSessao } from "../estado/sessao";

// Abas fixas no rodapé (13/08, referência visual passada pelo usuário) — substitui a `.nav-topo`
// no mobile (ver breakpoint em estilo.css). Os 4 destinos mais usados em campo ficam na barra;
// Templates/Equipe/Sair (uso esporádico, mais administrativo) vão pra `/mais`, uma página normal
// em vez de painel flutuante — consistente com o princípio já seguido no resto do app de evitar
// overlay/modal no mobile (ver comentário histórico em estilo.css sobre a antiga `.nav-topo`).
// Ícones outline (não emoji) — mesma família visual de componentes/Icones.tsx usada no resto do
// app desde a troca de marca pro azul (13/08).
const ITENS: {
  rotulo: string;
  rota: string;
  Icone: (props: { tamanho?: number; cor?: string }) => JSX.Element;
  combina: (caminho: string) => boolean;
}[] = [
  { rotulo: "Painel", rota: "/painel", Icone: IconeCasa, combina: (c) => c === "/painel" },
  { rotulo: "Vistorias", rota: "/vistorias", Icone: IconePrancheta, combina: (c) => c.startsWith("/vistorias") },
  // Mesmo ícone de Vistorias (IconePrancheta) — mesma reutilização já feita na barra lateral
  // desktop (Layout.tsx), sem ícone dedicado pra tarefas no set atual. A própria página se
  // autodenomina "Minhas tarefas" (vistoriador) ou "Tarefas da equipe" (admin) — o rótulo aqui no
  // menu fica fixo e curto, igual aos outros itens da barra.
  { rotulo: "Tarefas", rota: "/tarefas", Icone: IconePrancheta, combina: (c) => c.startsWith("/tarefas") },
  { rotulo: "Prédios", rota: "/clientes", Icone: IconePredio, combina: (c) => c.startsWith("/clientes") },
  { rotulo: "Agenda", rota: "/agenda", Icone: IconeCalendario, combina: (c) => c.startsWith("/agenda") },
  {
    rotulo: "Mais",
    rota: "/mais",
    Icone: IconeMais,
    combina: (c) => c.startsWith("/mais") || c.startsWith("/perfil") || c.startsWith("/templates") || c.startsWith("/equipe"),
  },
];

export function NavInferior() {
  const { pathname } = useLocation();
  const { usuario, sair } = useSessao();
  const superAdmin = usuario?.papel === "SUPER_ADMIN";
  const itens = superAdmin
    ? [{ rotulo: "Plataforma", rota: "/admin-geral", Icone: IconeCasa, combina: (caminho: string) => caminho.startsWith("/admin-geral") }]
    : ITENS;

  return (
    <nav className="nav-inferior" aria-label="Navegação principal">
      {itens.map((item) => {
        const ativa = item.combina(pathname);
        return (
          <Link key={item.rota} to={item.rota} className={`nav-inferior-item${ativa ? " ativa" : ""}`}>
            <span className={`nav-inferior-icone${ativa ? " nav-inferior-icone-ativa" : ""}`}>
              <item.Icone tamanho={20} cor={ativa ? "var(--primaria)" : "var(--texto-suave)"} />
            </span>
            {item.rotulo}
          </Link>
        );
      })}
      {superAdmin && <button type="button" className="nav-inferior-item nav-inferior-sair" onClick={() => void sair()}><span className="nav-inferior-icone" aria-hidden="true">↗</span>Sair</button>}
    </nav>
  );
}
